export class Quality{
    public readonly quality = {
        High: 0,
        Medium: 1,
        Low: 2
    }

    public readonly qualityString = {
        "0": "High",
        "1": "Medium",
        "2": "Low"
    }
}